/* 登录vuex */
import router from '@/router'
import axios from "../../utils/http"  //获取封装的axios
import { Message } from "element-ui"; //调用element-ui 的message功能

export default{
    namespaced:true,
    state:{
        userToken:'我是token',
    },
    mutations:{
        //数据处理,将token放在本地存储里面
        getToken(state,list){
            state.userToken = list
        },
    },
    actions:{
        //登录的接口调用
        loginActions({commit},ruleForm){
            axios.post('/sys/login',ruleForm).then(response =>{
                if (response.code === 200) {
                    localStorage.setItem('token',JSON.stringify(response.data.token))
                    commit('getToken',response.data.token)
                    router.push('/layout')
                    Message({
                        message:response.message,
                        type:'success'
                    })
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        }
    },
    getters:{

    }
}